export const ACCOUNT_BALANCE_DASHBOARD_DOMAINS = ["myskoolcrestviewacademy"];

export function normalizeReportDomain(reportDomain) {
  return String(reportDomain || "").toLowerCase().replace(/_/g, "");
}

export function isAccountBalanceDashboardDomain(reportDomain) {
  return ACCOUNT_BALANCE_DASHBOARD_DOMAINS.includes(
    normalizeReportDomain(reportDomain)
  );
}

export function hasAccountBalanceViewRights(rights) {
  const r = rights || {};
  return !!(r.journal?.view || r.accounts?.view);
}

export function canShowAccountBalanceDashboard(reportDomain, rights) {
  return (
    isAccountBalanceDashboardDomain(reportDomain) &&
    hasAccountBalanceViewRights(rights)
  );
}
